// extracted by mini-css-extract-plugin
var _1 = "IntegrationSelectSetting-module__section--rzPto";
export { _1 as "section" }
